import _ from 'underscore';
import Backbone from 'backbone';
import CatalogItem from './CatalogItem';

export default Backbone.Model.extend({
    set: function (key, value, options) {
        // Normalize the key-value into an object
        let attrs;

        if (_.isObject(key) || key === null) {
            attrs = key;
            options = value;
        } else {
            attrs = {};
            attrs[key] = value;
        }

        // Go over all the set attributes and make your changes
        for (const attr in attrs) {
            if (attr === 'catalogItem' && !(attrs[attr] instanceof Backbone.Model)) {
                attrs[attr] = new CatalogItem(attrs[attr]);
            }
        }

        return Backbone.Model.prototype.set.call(this, attrs, options);
    }
});


// WEBPACK FOOTER //
// ./model/ShoppingCartItem.js